/*
Copyright (C) 2020 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
import { CollectionStateHook } from '@broadleaf/admin-components/dist/collection/hooks/useCollectionState';
import {
  IActionComponent,
  IMetadata,
  IMetadataAction
} from '@broadleaf/admin-components/dist/types/metadata';
import {
  IOrderFulfillment,
  IOrderLocalState
} from '@broadleaf/admin-components/dist/types/oms';
import React, { ComponentType, Dispatch, FC } from 'react';

import type {
  FulfillmentCardBodyProps,
  ItemsOrderViewSectionComponents,
  FulfillmentCardContainerProps,
  FulfillmentCardHeaderProps,
  FulfillmentCardBodyComponents
} from '..';

import { FulfillmentCard } from '@broadleaf/admin-components/dist/oms/components/ItemsOrderViewSection/components';

export interface FulfillmentCardProps {
  actionComponents: Array<IActionComponent>;
  actionDefinitions: Array<IMetadataAction>;
  fulfillment: IOrderFulfillment;
  fulfillmentsState: CollectionStateHook;
  itemsMetadata: IMetadata;
  itemsViewComponents: ItemsOrderViewSectionComponents;
  orderDispatch: Dispatch<any>;
  orderMetadata: IMetadata;
  orderState: IOrderLocalState;
}

export interface FulfillmentCardComponents {
  Body: ComponentType<FulfillmentCardBodyProps> & FulfillmentCardBodyComponents;
  Container: ComponentType<FulfillmentCardContainerProps>;
  Header: ComponentType<FulfillmentCardHeaderProps>;
}

export const RmFulfillmentCard = props => {
  return <FulfillmentCard components {...props} />;
};

export default RmFulfillmentCard;
